import { createFileRoute } from "@tanstack/react-router";
import { seo, seoLinks } from "~/utils/seo";
import { PricingModels } from "~/components/pricing/PricingModels";
import { PricingFaq } from "~/components/pricing/PricingFaq";
import { FinalCta } from "~/components/pricing/FinalCta";

export const Route = createFileRoute("/pricing/")({
  loader: () => ({}),
  head: () => ({
    meta: seo({
      title: "C1 pricing — Platform and Flex pricing models",
      description:
        "Compare predictable, SKU-based C1 Platform pricing with Flex usage-based pricing. Configure products, program size, hosting, and support.",
      url: "/pricing",
    }),
    links: seoLinks({ url: "/pricing" }),
  }),
  component: PricingIndex,
});

function PricingIndex() {
  return (
    <>
      <a
        href="#pricing-models"
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-lg focus:bg-charcoal focus:px-4 focus:py-2 focus:font-body focus:text-sm focus:font-semibold focus:text-white"
      >
        Skip to pricing models
      </a>
      <PricingModels />
      <PricingFaq />
      <FinalCta />
    </>
  );
}
